var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.className,attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('Confirm'),_c('Alerts'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }